import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FModal from '~/js/components/modal'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'

const REGIONS = [
  '北海道',
  '東北',
  '北陸/甲信越',
  '東京',
  '関東',
  '東海',
  '関西',
  '中国/四国',
  '九州/沖縄',
]

const getProductStoresStock = async (sku) => {
  if (!sku) return

  const url = `${baseUrlFrontApi}/storestock/${sku}`

  try {
    return await $.ajax({
      url,
      type: 'GET',
      crossDomain: true,
      cache: true,
      dataType: 'json',
    }).then((result) => {
      return result
    })
  } catch (e) {
    console.error(e)
  }
}

export const initStoresStockModal = async (element) => {
  const sku = element.dataset.sku
  const storesStock = await getProductStoresStock(sku)
  const elementSettings = document.getElementById('js-product-stock-settings')
  const settings = elementSettings.dataset

  const storesList = JSON.parse(settings.storesList)
  const indexSelectedRegion = REGIONS.indexOf('東京')

  const storesListWithStatus = storesList
    .filter((store) => !store.store_closed)
    .map((store) => {
      const stock = storesStock.find((s) => s.store_id == store.store_id)
      return {
        name: store.store,
        region: store.region,
        prefecture: store.prefecture,
        storeNumber: store.store_number,
        status: stock ? stock.status : 'NONE',
      }
    })

  const storesGrouped = REGIONS.map((region) => {
    const storesInRegion = storesListWithStatus.filter(
      (store) => store.region === region
    )
    const prefecturesInRegion = []
    storesInRegion.forEach((store) => {
      if (!prefecturesInRegion.includes(store.prefecture))
        prefecturesInRegion.push(store.prefecture)
    })

    return prefecturesInRegion.map((prefecture) => {
      const stores = storesInRegion
        .filter((store) => store.prefecture === prefecture) // 県に属する店舗をフィルター
        .filter((store) => {
          // 在庫状況と設定に応じて表示する店舗をフィルター
          return !(
            (settings.hideStoresNoStock == 'true' && store.status === 'NONE') ||
            (settings.hideStoresBelowThresholdStock == 'true' &&
              store.status === 'LOW') ||
            (settings.hideStoresAboveThresholdStock === 'true' &&
              store.status === 'ENOUGH')
          )
        })
        .map((store) => {
          // 在庫状況によって表示するテキストをセット
          let stockText = '---'
          if (store.status === 'NONE') stockText = settings.noStockText
          else if (store.status === 'LOW') stockText = settings.lowStockText
          else if (store.status === 'ENOUGH') stockText = settings.highStockText
          return {
            ...store,
            stockText,
          }
        })

      return {
        prefecture,
        stores,
      }
    })
  })

  createApp({
    name: 'TemplatesProductModal',
    components: {
      FButton,
      FModal,
    },
    data() {
      return {
        isStoresStockModalShow: window.location.href.includes('#inventory'),
        regions: REGIONS,
        indexSelectedRegion,
      }
    },
    computed: {
      storesToShow() {
        return storesGrouped[this.indexSelectedRegion]
      },
    },
    created() {
      const elementsTrigger = document.getElementsByClassName(
        'js-modal-product-stock-trigger'
      )
      if (elementsTrigger.length) {
        Array.from(elementsTrigger).forEach((element) => {
          element.addEventListener('click', () => {
            this.isStoresStockModalShow = true
          })
        })
      }
    },
  }).mount(element)
}
